import { AiOutlineLeft } from '@react-icons/all-files/ai/AiOutlineLeft';
import { AiOutlineRight } from '@react-icons/all-files/ai/AiOutlineRight';
import React from 'react';
export const ChevronRight = ({ size, color }) => (<AiOutlineRight style={{ fontSize: size, color }}/>);
export const ChevronLeft = ({ size, color }) => (<AiOutlineLeft style={{ fontSize: size, color }}/>);
